import { BreadcrumbItem } from './breadcrumb-item';

import clsx from 'clsx';

type BreadcrumbProps<T> = {
  items: BreadcrumbItem<T>[];
  currentItem: BreadcrumbItem<T>;
  className?: string;
  itemClassName?: string;
  onItemClicked: (item: BreadcrumbItem<T>) => void;
};

export function Breadcrumb<T extends string | number>({
  items,
  currentItem,
  className,
  itemClassName,
  onItemClicked,
}: BreadcrumbProps<T>) {
  const handleItemClicked = (item: BreadcrumbItem<T>, isPrevious: boolean) => {
    if (isPrevious) {
      return onItemClicked(item);
    }
  };

  return (
    <div className="flex items-start gap-3 text-xs">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isCurrent = item === currentItem;
        const isPrevious = index < items.indexOf(currentItem);
        const isAfter = !isCurrent && !isPrevious;

        return (
          <div
            key={item.value}
            className={clsx('flex items-start gap-3', className)}
          >
            <button
              className={clsx(
                'text-left',
                isCurrent && 'font-bold cursor-default',
                isPrevious && 'text-ocean-60',
                isAfter && 'text-teal-5 cursor-default',
                itemClassName
              )}
              onClick={() => handleItemClicked(item, isPrevious)}
            >
              {item.label}
            </button>
            {!isLast && <div className="pt-[2px] cursor-default">{'>'}</div>}
          </div>
        );
      })}
    </div>
  );
}
